import { Stack } from '@mui/material';
import React from 'react';
import { Label } from './label';
import { Value } from './value';

interface Props {
  label: string;
  value: React.ReactNode;
  testId?: string;
}

export function ViewLabelValue({ label, value, testId }: Props) {
  return (
    <Stack>
      <Label>{label}</Label>
      <Value testId={testId}>{value}</Value>
    </Stack>
  );
}
